import React, { useEffect, useState } from 'react';
import { loadTossPayments } from '@tosspayments/payment-sdk';
import constraints from '../../constraints';
import { Buffer } from 'buffer'

// create random A~Z 6 length string
function createRandomString(length) {
  const chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
  let result = '';
  for (let i = length; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)];
  return result;
}

export default function Try() { 
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    let userUUID = params.get('user_uuid');
    let userName = params.get('user_name');

    userUUID = Buffer.from(userUUID, 'base64').toString();
    userName = Buffer.from(userName, 'base64').toString();

    console.log(userUUID)
    console.log(userName)

    loadTossPayments(constraints.config.TOSS_CLIENT_KEY).then(tossPayments => {
      tossPayments.requestPayment('카드', { // 결제 수단 파라미터
        // 결제 정보 파라미터
        amount: 10000,
        orderId: `answerit-${createRandomString(6)}`,
        orderName: `카카오톡 프로필조회`,
        // customerName: '박토스',
        successUrl: `${constraints.config.HOST_URL}/purchase/redirect/kakaoauth/success`,
        failUrl: constraints.config.TOSS_PAYMENT_FAIL_CALLBACK_URL
      });
    });

    // 구독결제용
    // loadTossPayments(constraints.config.TOSS_CLIENT_KEY).then(tossPayments => {
    //   tossPayments.requestBillingAuth('카드', { // 결제 수단 파라미터
    //     // 빌링키 발급 요청을 위한 파라미터
    //     // customerKey : '고객 식별 키',
    //     // customerEmail : '고객 이메일', ( OPTIONS )
    //     customerName: userUUID,
    //     customerKey: userUUID,
    //     successUrl: `${constraints.config.HOST_URL}/purchase/redirect/kakaoauth/success`,
    //     failUrl: constraints.config.TOSS_PAYMENT_FAIL_CALLBACK_URL
    //   });
    // });
  }, []);
  
  return (
    <div className="w-full h-full flex flex-col justify-center items-center">

    </div>
  )
}